import React, { Component } from 'react';
import PhoneInput from './phone-input.js';


class FormPhoneInput extends Component {
	handleOnChange = (value) => {
		const { form, field } = this.props;

		form.setFieldValue(field.name, value);
	};

	handleOnBlur = () => {
		const { form, field } = this.props;

		form.setFieldTouched(field.name, true);
	};

	render() {
		const { field, form, ...props } = this.props;

		return (
			<PhoneInput
				{...field}
				{...form}
				{...props}
				value={field.value}
				onChange={this.handleOnChange}
				onBlur={this.handleOnBlur}
			/>
		);
	}
}

export default FormPhoneInput;
